/**
 * BlogCTA.tsx — Gold Garage Door / Blog Hub · Section 4/4
 * Cream → compact CTA. Phone + WhatsApp. Short — this is a hub page, not a sales page.
 * WhatsApp text MUST be navy (#081438) on green — never white.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep inline SVG + <style>. Wave divider at top intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";

/** phone — DO NOT REPLACE WITH IMG */
const IconPhone = () => <svg data-icon-container="lucide-do-not-replace" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={NAVY} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
export default function BlogCTA() {
  return <section id="blog-cta" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "4rem",
    paddingBottom: "4.5rem"
  }}>
      <style>{`@media (max-width: 560px) { #blog-cta { padding-top: 3rem; padding-bottom: 3.5rem; } }`}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-blcta"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-blcta)" /></svg>

      <div style={{
      maxWidth: "680px",
      margin: "0 auto",
      padding: "0 1.5rem",
      textAlign: "center",
      position: "relative",
      zIndex: 1
    }}>
        <h2 style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 800,
        fontSize: "clamp(1.5rem, 5vw, 2rem)",
        color: NAVY,
        lineHeight: 1.15,
        marginBottom: "0.75rem"
      }}>
          Need help now? <span style={{
          color: GOLD_DARK
        }}>Skip the reading.</span>
        </h2>
        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "1rem",
        color: "#5A6478",
        lineHeight: 1.7,
        marginBottom: "1.75rem"
      }}>
          Call the crew that wrote the blog — we're faster than a search result.
        </p>

        <div style={{
        display: "flex",
        gap: "1rem",
        justifyContent: "center",
        flexWrap: "wrap"
      }}>
          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "0.875rem 1.75rem",
          background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
          color: NAVY,
          fontWeight: 700,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "0.95rem",
          boxShadow: `0 4px 20px ${GOLD}35`
        }}>
            <IconPhone /> 0485 000 933
          </a>
          <a href="https://wa.me/61485000933?text=Hi%20Gold%20Garage%20Door%2C%20I%20need%20some%20advice" target="_blank" rel="noopener noreferrer" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "0.875rem 1.75rem",
          background: "#25D366",
          color: NAVY,
          fontWeight: 700,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "0.95rem",
          boxShadow: "0 4px 20px rgba(37,211,102,0.3)"
        }}>
            WhatsApp us
          </a>
        </div>
      </div>
    </section>;
}